const ActionDDT = {
  UPLOAD: 0,
  UPDATE: 1,
  ASSOCIATE: 2,
};

export { ActionDDT };